<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
      novalidate
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.details }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mainForm.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.title }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="mainForm.title"
                      />

                      <form-error
                        :model="$v.mainForm.title"
                        :label="translations.forms.labels.title"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Zadana brza pošta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="mainForm.defaultExpressPost"
                          id="default-express-post"
                        />
                        <label for="default-express-post"></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mainForm.description.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.description }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.description"
                        v-model="mainForm.description"
                      />

                      <form-error
                        :model="$v.mainForm.description"
                        :label="translations.forms.labels.description"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mainForm.address.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.address }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.address"
                        v-model="mainForm.address"
                      />

                      <form-error
                        :model="$v.mainForm.address"
                        :label="translations.forms.labels.address"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mainForm.phone.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.phone }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.phone"
                        v-model="mainForm.phone"
                      />

                      <form-error
                        :model="$v.mainForm.phone"
                        :label="translations.forms.labels.phone"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mainForm.fax.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.fax }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.fax"
                        v-model="mainForm.fax"
                      />

                      <form-error
                        :model="$v.mainForm.fax"
                        :label="translations.forms.labels.fax"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.mainForm.defaultPrice.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.defaultPrice }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.defaultPrice"
                        v-model.number="mainForm.defaultPrice"
                      />

                      <form-error
                        :model="$v.mainForm.defaultPrice"
                        :label="translations.forms.labels.defaultPrice"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.mainForm.officeNumber.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.officeNumber }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.officeNumber"
                        v-model="mainForm.officeNumber"
                      />

                      <form-error
                        :model="$v.mainForm.officeNumber"
                        :label="translations.forms.labels.officeNumber"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mainForm.countryId.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.country }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div
                        :class="{ has__error: $v.mainForm.countryId.$anyError }"
                      >
                        <vue-select
                          :options="countries"
                          v-model="mainForm.countryId"
                          :custom-label="customLabel"
                          @search-change="getCountries"
                          id="id"
                          :loading="isLoading"
                          @select="getTownsByCountryId"
                          placeholder="Izaberite državu"
                        >
                          <template slot="noOptions">
                            Lista je prazna
                          </template>
                          <template slot="noResult">
                            Nema rezultata prema zadanim parametrima
                          </template>
                        </vue-select>
                      </div>

                      <form-error
                        :model="$v.mainForm.countryId"
                        :label="translations.forms.labels.country"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mainForm.townId.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.town }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div
                        :class="{ has__error: $v.mainForm.townId.$anyError }"
                      >
                        <vue-select
                          :options="towns"
                          v-model="mainForm.townId"
                          :custom-label="customLabel"
                          @search-change="getTowns"
                          id="town-id"
                          :loading="isLoading"
                          placeholder="Izaberite grad"
                        >
                          <template slot="noOptions">
                            Lista je prazna
                          </template>
                          <template slot="noResult">
                            Nema rezultata prema zadanim parametrima
                          </template>
                        </vue-select>
                      </div>

                      <form-error
                        :model="$v.mainForm.townId"
                        :label="translations.forms.labels.town"
                        :dirty="$v.mainForm.$dirty"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div
          class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
        >
          <router-link
            exact
            :to="{ name: 'ExpressPosts' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
        <div class="action-buttons" style="margin-top: 2rem">
          <div
            class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
          >
            <router-link
              exact
              :to="{ name: 'ExpressPosts' }"
              class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            >
              Otkaži
            </router-link>
            <button
              type="submit"
              class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            >
              <i class="bx bx-save text-4 me-2"></i>{{ translations.save }}
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <div class="card card-modern card-modern-table-over-header">
            <div class="card-header">
              <div class="row align-items-center mb-5">
                <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                  <a
                    @click="openAddRangeModal"
                    class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                  >
                    + Dodaj stavku
                  </a>
                  <button
                    class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                    type="button"
                    @click.prevent.stop="showConfirmationModal"
                  >
                    - Ukloni stavku
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body" style="margin-top: -20px">
              <table
                v-if="expressPostRanges.length"
                class="table table-offer table-ecommerce-simple table-borderless table-striped mb-0"
                style="min-width: 640px"
              >
                <thead>
                  <tr>
                    <th width="30">
                      <input
                        type="checkbox"
                        class="select-all checkbox-style-1 p-relative top-2"
                        v-model="selectAll"
                      />
                    </th>
                    <th>RBR</th>
                    <th>Kg od</th>
                    <th>Kg do</th>
                    <th>Cijena</th>
                    <th>Akcije</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in expressPostRanges"
                    :key="item.generatedId"
                  >
                    <td width="30">
                      <input
                        type="checkbox"
                        class="checkbox-style-1 p-relative top-2"
                        :value="item.generatedId"
                        v-model="selected"
                      />
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.minWeight }}</td>
                    <td>
                      <strong>{{ item.maxWeight }}</strong>
                    </td>
                    <td>
                      <strong>{{ item.deliveryPrice }}</strong>
                    </td>
                    <td @click.prevent.stop="showEditModal(item)">
                      <i class="fa fa-edit"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }}
                </div>
              </div>
              <hr class="solid mt-5 opacity-4" />
              <div class="datatable-footer" v-if="expressPostRanges.length > 4">
                <div
                  class="row align-items-center justify-content-between mt-3"
                >
                  <div class="col-md-auto order-1 mb-3 mb-lg-0">
                    <div class="d-flex align-items-stretch">
                      <a
                        @click="openAddRangeModal"
                        class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                        >+ Dodaj stavku</a
                      >
                      <button
                        class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                        type="button"
                        @click.prevent.stop="showConfirmationModal"
                      >
                        - Ukloni stavku
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="action-buttons" style="margin-top: 2rem">
          <div
            class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
          >
            <router-link
              exact
              :to="{ name: 'ExpressPosts' }"
              class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            >
              Otkaži
            </router-link>
            <button
              type="submit"
              class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            >
              <i class="bx bx-save text-4 me-2"></i>{{ translations.save }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <form @submit.prevent="addRange">
      <modal id="add-range" cssClass="modal-md-2">
        <header slot="header">
          <h2 class="card-title">Dodavanje stavke</h2>
        </header>
        <section slot="body">
          <div class="card-body">
            <div class="form-group row">
              <label
                class="col-lg-2 control-label text-lg-end pt-2"
                for="add-min-weight"
                >KG od</label
              >
              <div class="col-lg-10">
                <input
                  placeholder="KG od"
                  type="text"
                  class="form-control form-control-modern"
                  id="add-min-weight"
                  v-model.number="itemNewForm.minWeight"
                  readonly
                />
                <form-error
                  :model="$v.itemNewForm.minWeight"
                  :dirty="$v.itemNewForm.$dirty"
                  :label="translations.forms.labels.minWeight"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-lg-2 control-label text-lg-end pt-2"
                for="add-max-weight"
                >KG do</label
              >
              <div class="col-lg-10">
                <input
                  placeholder="KG do"
                  type="text"
                  class="form-control form-control-modern"
                  id="add-max-weight"
                  v-model.number="itemNewForm.maxWeight"
                />
                <form-error
                  :model="$v.itemNewForm.maxWeight"
                  :dirty="$v.itemNewForm.$dirty"
                  :label="translations.forms.labels.maxWeight"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-lg-2 control-label text-lg-end pt-2"
                for="add-delivery-price"
                >Cijena</label
              >
              <div class="col-lg-10">
                <input
                  placeholder="Cijena"
                  type="text"
                  class="form-control form-control-modern"
                  id="add-delivery-price"
                  v-model.number="itemNewForm.deliveryPrice"
                />
                <form-error
                  :model="$v.itemNewForm.deliveryPrice"
                  :dirty="$v.itemNewForm.$dirty"
                  :label="translations.forms.labels.deliveryPrice"
                />
              </div>
            </div>
          </div>
        </section>
        <footer slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <!-- <button
                class="btn btn-default modal-dismiss mx-2"
                aria-label="Close"
                @click="closeNewModal"
              >
                Odustani
              </button> -->
              <button class="btn btn-primary modal-confirm" type="submit">
                Dodaj stavku
              </button>
            </div>
          </div>
        </footer>
      </modal>
    </form>

    <form @submit.prevent="editRange">
      <modal id="edit-range" cssClass="modal-md-2" v-if="itemEditForm">
        <header slot="header">
          <h2 class="card-title">Ažuriranje stavke</h2>
        </header>
        <section slot="body">
          <div class="card-body">
            <div class="form-group row">
              <label
                class="col-lg-2 control-label text-lg-end pt-2"
                for="edit-min-weight"
                >KG od</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id="edit-min-weight"
                  v-model.number="itemEditForm.minWeight"
                  disabled
                />
                <form-error
                  :model="$v.itemEditForm.minWeight"
                  :dirty="$v.itemEditForm.$dirty"
                  :label="translations.forms.labels.minWeight"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-lg-2 control-label text-lg-end pt-2"
                for="edit-max-weight"
                >KG do</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id="edit-max-weight"
                  v-model.number="itemEditForm.maxWeight"
                  :disabled="isEditMaxWeightReadonly"
                />
                <form-error
                  :model="$v.itemEditForm.maxWeight"
                  :dirty="$v.itemEditForm.$dirty"
                  :label="translations.forms.labels.maxWeight"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-lg-2 control-label text-lg-end pt-2"
                for="edit-delivery-price"
                >Cijena</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id="edit-delivery-price"
                  v-model.number="itemEditForm.deliveryPrice"
                />
                <form-error
                  :model="$v.itemEditForm.deliveryPrice"
                  :dirty="$v.itemEditForm.$dirty"
                  :label="translations.forms.labels.deliveryPrice"
                />
              </div>
            </div>
          </div>
        </section>
        <footer slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button class="btn btn-primary modal-confirm" type="submit">
                Spremi
              </button>
            </div>
          </div>
        </footer>
      </modal>
    </form>
    <modal id="confirm-delete">
      <h5 slot="header">
        <strong>Ukloni odabrane stavke</strong>
      </h5>
      <div slot="body">
        Jeste li sigurni da želite ukloniti odabrane stavke?
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="removeRanges"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import VueSelect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import { translations } from '@/mixins';
import validations from './validation-schema/add';
import itemValidation from './validation-schema/itemAddOrEdit';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';

import Modal from '@/components/shared/modal/Modal.vue';

export default {
  name: 'AddExpressPost',
  mixins: [translations],
  components: {
    VueSelect,
    FormError,
    Modal,
  },
  validations: {
    mainForm: validations,
    itemNewForm: itemValidation,
    itemEditForm: itemValidation,
  },
  data() {
    return {
      mainForm: {
        title: '',
        description: '',
        address: '',
        phone: '',
        defaultPrice: '',
        fax: '',
        countryId: null,
        townId: null,
        officeNumber: '',
        defaultExpressPost: false,
      },
      itemNewForm: {
        minWeight: null,
        maxWeight: null,
        deliveryPrice: null,
        generatedId: null,
      },
      itemEditForm: {
        minWeight: null,
        maxWeight: null,
        deliveryPrice: null,
        generatedId: null,
      },
      isLoading: false,
      expressPostRanges: [],
      selected: [],
      tempObj: {}
    };
  },
  computed: {
    selectAll: {
      get: function () {
        return this.selected.length === this.expressPostRanges.length;
      },
      set: function (value) {
        const selected = [];

        if (value) {
          this.expressPostRanges.forEach(function ({ generatedId }) {
            selected.push(generatedId);
          });
        }

        this.selected = selected;
      },
    },
    countries() {
      return this.$store.getters.getCountries.map(({ id, title }) => ({
        id,
        title,
      }));
    },
    towns() {
      return this.$store.getters.getTowns.map(({ id, title }) => ({
        id,
        title,
      }));
    },
    isMainFormValid() {
      return !this.$v.mainForm.$invalid;
    },
    isItemNewFormValid() {
      return !this.$v.itemNewForm.$invalid;
    },
    isItemEditFormValid() {
      return !this.$v.itemEditForm.$invalid;
    },
    isEditMaxWeightReadonly() {
      return this.expressPostRanges.filter(x=>x.generatedId !== this.itemEditForm.generatedId && x.maxWeight > this.tempObj.maxWeight).length > 0;
    }
  },
  methods: {
    openAddRangeModal() {
      this.$v.itemNewForm.$reset();

      $('#add-range').modal('show');
      if (this.expressPostRanges.length > 0) {
        const maxWeight = this.expressPostRanges.reduce(
          (max, range) => (range.maxWeight > max ? range.maxWeight : max),
          this.expressPostRanges[0].maxWeight
        );
        this.itemNewForm.minWeight = maxWeight + 0.01;
      } else {
        this.itemNewForm.minWeight = 0;
      }
    },
    editRange() {
      this.$v.itemEditForm.$touch();

      if (!this.isItemEditFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      var areCorrectValues = this.expressPostRanges.some(
        (x) =>
          x.generatedId != this.itemEditForm.generatedId &&
          ((this.itemEditForm.minWeight <= x.minWeight &&
            this.itemEditForm.maxWeight >= x.maxWeight) ||
            (this.itemEditForm.maxWeight >= x.minWeight &&
              this.itemEditForm.maxWeight <= x.maxWeight) ||
            (this.itemEditForm.minWeight >= x.minWeight &&
              this.itemEditForm.minWeight <= x.maxWeight))
      );
      if (this.itemEditForm.minWeight >= this.itemEditForm.maxWeight) {
        this.$toast.error('Neispravne vrijednosti kilaže!');
      } else if (areCorrectValues) {
        this.$toast.error('KG već postoji u stavkama!');
      } else {
        let obj = this.expressPostRanges.filter(
          (x) => x.generatedId == this.itemEditForm.generatedId
        )[0];
        obj.maxWeight = this.itemEditForm.maxWeight;
        obj.minWeight = this.itemEditForm.minWeight;
        obj.deliveryPrice = this.itemEditForm.deliveryPrice;
        obj.generatedId = this.itemEditForm.generatedId;
        $('#edit-range').modal('hide');
      }
    },
    showEditModal(item) {
      this.tempObj = item;
      this.itemEditForm.maxWeight = item.maxWeight;
      this.itemEditForm.minWeight = item.minWeight;
      this.itemEditForm.deliveryPrice = item.deliveryPrice;
      this.itemEditForm.generatedId = item.generatedId;
      setTimeout(() => {
        $('#edit-range').modal('show');
      }, 100);
    },
    generateRandomId() {
      return -Math.ceil(Math.random() * 1000000);
    },
    showConfirmationModal() {
      if (this.selected.length) $('#confirm-delete').modal('show');
    },
    closeNewModal() {
      $('#add-range').modal('hide');
      this.$v.itemNewForm.$reset();
      this.itemNewForm.maxWeight = null;
      this.itemNewForm.minWeight = null;
      this.itemNewForm.deliveryPrice = null;
      this.itemNewForm.generatedId = null;
    },
    closeEditModal() {
      $('#edit-range').modal('hide');
    },
    addRange() {
      this.$v.itemNewForm.$touch();

      if (!this.isItemNewFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      var areCorrectValues = this.expressPostRanges.some(
        (x) =>
          (this.itemNewForm.minWeight <= x.minWeight &&
            this.itemNewForm.maxWeight >= x.maxWeight) ||
          (this.itemNewForm.maxWeight >= x.minWeight &&
            this.itemNewForm.maxWeight <= x.maxWeight) ||
          (this.itemNewForm.minWeight >= x.minWeight &&
            this.itemNewForm.minWeight <= x.maxWeight)
      );

      if (this.itemNewForm.minWeight >= this.itemNewForm.maxWeight) {
        this.$toast.error('Neispravne vrijednosti kilaže!');
      } else if (areCorrectValues) {
        this.$toast.error('KG već postoji u stavkama!');
      } else {
        this.itemNewForm.generatedId = this.generateRandomId();
        this.expressPostRanges.push({ ...this.itemNewForm });
        this.closeNewModal();
      }
    },
    customLabel({ title }) {
      return title;
    },
    removeRanges() {
      if (this.selected.length === this.expressPostRanges) {
        this.expressPostRanges = this.expressPostRanges.filter(
          (item) => !this.selected.includes(item.generatedId)
        );
      } else {
        let data = [...this.expressPostRanges];
        data.sort((a, b) => b.maxWeight - a.maxWeight);
        let length =
          this.selected.length > data.length
            ? data.length
            : this.selected.length;
        for (let i = 0; i < length; i++) {
          if (this.selected.includes(data[i].generatedId)) {
            this.expressPostRanges = this.expressPostRanges.filter(
              (item) => item.generatedId != data[i].generatedId
            );
          } else {
            this.$toast.error(
              'Molimo da prvo obrišete stavke sa maksimalnom kilažom'
            );
            break;
          }
        }
      }
    },
    submitForm() {
      this.$v.mainForm.$touch();

      if (!this.isMainFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const {
        title,
        description,
        address,
        phone,
        fax,
        defaultPrice,
        townId,
        officeNumber,
        defaultExpressPost,
      } = this.mainForm;

      const { expressPostRanges } = this;

      api
        .createExpressPost({
          title,
          description,
          address,
          phone,
          fax,
          defaultPrice,
          townId: townId.id,
          officeNumber,
          defaultExpressPost,
          expressPostRanges,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'ExpressPosts' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    getCountries(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getCountries', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    getTownsByCountryId({ id }) {
      this.$store
        .dispatch('getTowns', {
          countryId: id,
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getTowns(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getTowns', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    onCountryChange() {
      this.mainForm.townId = null;
      this.$store.dispatch('getTowns', {
        sortBy: 'title',
        isSortAscending: false,
        retrieveAll: true,
        countryId: this.mainForm.countryId,
      });
    },
  },
  mounted() {
    this.$store.dispatch('getCountries', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
  },
};
</script>

<style lang="scss" scoped>
.has__error {
  border: 1px solid #d2322d;
  border-radius: 5px;
}

.vue-treeselect__placeholder {
  color: #000;
}

.vue-treeselect__placeholder,
.vue-treeselect__single-value {
  line-height: 45px;
}

.vue-treeselect__control {
  height: 45px;
  font-size: 0.85rem;
}
</style>
